var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 160,
    viewBox: "0 0 202 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4648 159.647H61.6782V146.221H73.1902V149.353H66.3079V151.272H72.1334V154.404H66.3079V156.511H73.4648V159.643V159.647Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0349 146.221L85.0745 153.548L84.8977 150.491V146.221H89.328V159.647H84.9955L79.9559 152.339L80.1327 155.396V159.647H75.7024V146.221H80.0349Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.958 159.647H92.1714V146.221H103.683V149.353H96.801V151.272H102.627V154.404H96.801V156.511H103.958V159.643V159.647Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.074 154.968H110.664V159.647H106.034V146.221H112.702C115.004 146.221 116.636 146.532 117.603 147.152C118.505 147.738 118.957 148.699 118.957 150.044C118.957 151.82 118.167 152.917 116.583 153.326C117.471 153.638 118.061 153.961 118.347 154.295C118.765 154.791 118.975 155.655 118.975 156.887C118.975 157.931 118.987 158.539 119.013 158.716C119.066 159.065 119.216 159.238 119.464 159.238V159.647H114.778C114.62 159.249 114.541 158.468 114.541 157.296C114.541 156.376 114.398 155.767 114.109 155.467C113.782 155.133 113.101 154.964 112.07 154.964L112.074 154.968ZM110.664 149.353V152.019H112.488C113.951 152.019 114.684 151.595 114.684 150.75C114.684 149.819 114.064 149.353 112.823 149.353H110.664Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.645 153.81H124.763C124.763 154.756 124.816 155.413 124.921 155.785C125.09 156.409 125.444 156.716 125.978 156.716C126.764 156.716 127.155 156.168 127.155 155.075V146.216H131.781V154.459C131.781 158.151 129.946 159.999 126.271 159.999C122.597 159.999 120.604 158.253 120.604 154.76C120.604 154.448 120.615 154.133 120.641 153.81H120.645Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.291 159.646H134.666V146.22H139.291V159.646ZM138.663 144.894H135.271V142.468H138.663V144.894Z",
    fill: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.204 123.401H189.194C190.514 123.401 191.451 123.225 192.007 122.864C192.59 122.511 192.88 121.831 192.88 120.836C192.88 119.788 192.564 119.075 191.928 118.692C191.372 118.384 190.383 118.234 188.965 118.234H185.204V123.405V123.401ZM176.535 139.119V111.552H189.612C193.613 111.552 196.49 112.142 198.239 113.318C200.086 114.549 201.015 116.604 201.015 119.492C201.015 122.759 199.544 125.039 196.607 126.316C198.126 126.642 199.228 127.288 199.913 128.235C200.597 129.181 200.977 130.582 201.052 132.452L201.203 136.283C201.229 136.974 201.267 137.41 201.316 137.594C201.417 137.898 201.646 138.063 202 138.089V139.122H193.143C192.816 137.774 192.65 136.813 192.65 136.249V133.496C192.65 132.062 192.372 131.063 191.816 130.503C191.259 129.914 190.296 129.621 188.927 129.621H185.204V139.122H176.539L176.535 139.119ZM150.047 139.119V111.552H171.902V118.147H158.829V121.828H169.89V128.152H158.829V132.411H172.436V139.115H150.051L150.047 139.119ZM125.76 139.119V111.552H134.538V131.795H146.475V139.115H125.76V139.119ZM96.1165 139.119V111.552H104.823V120.678L112.687 111.552H122.871L113.104 121.715L124.127 139.119H113.676L106.985 128.077L104.819 130.338V139.119H96.1127H96.1165ZM81.8252 139.119V111.552H90.7573V139.119H81.8252ZM57.3909 139.119V111.552H66.1687V131.795H78.102V139.115H57.3871L57.3909 139.119ZM30.8993 139.119V111.552H52.7537V118.147H39.6809V121.828H50.7416V128.152H39.6809V132.411H53.2877V139.115H30.9031L30.8993 139.119ZM17.3414 139.633L15.1112 144.5L8.16861 144.403L10.899 139.633C8.00313 139.137 5.62626 137.936 3.76463 136.016C1.25613 133.406 0 129.857 0 125.358C0 120.859 1.24109 117.325 3.72326 114.737C6.23176 112.135 9.62782 110.831 13.9115 110.831C17.8641 110.831 20.9668 111.8 23.2196 113.742C25.5024 115.665 26.7811 118.414 27.0594 121.982H18.6614C18.3831 119.15 16.8374 117.727 14.0243 117.727C10.5793 117.727 8.85684 120.273 8.85684 125.358C8.85684 130.443 10.6545 132.986 14.2537 132.986C17.0668 132.986 18.6125 131.468 18.8908 128.426H27.2136C26.9617 132.058 25.6943 134.886 23.4152 136.903C21.8018 138.311 19.7784 139.22 17.3414 139.637V139.633Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8151 138.597L15.111 144.497L8.16846 144.403L11.73 138.176L17.8151 138.597Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7575 104.684H81.8254V109.607H90.7575V104.684Z",
    fill: "#19398A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.446 0.256348L130.991 1.15769L129.535 21.4868L110.949 20.3188L112.446 0.256348Z",
    fill: "url(#paint0_linear_258_693)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4198 64.8376C86.3754 67.4816 88.914 69.9716 92.0205 72.2587C98.9555 77.3476 106.677 79.9352 114.969 79.9277C125.725 79.9277 134.105 75.5073 135.744 74.5759C132.713 73.8361 118.433 70.9067 118.433 70.9067C118.433 70.9067 96.9811 80.4347 84.416 64.8376H84.4198Z",
    fill: "url(#paint1_linear_258_693)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6343 44.3804C70.1327 32.0132 80.0313 25.9403 89.2868 23.0035C100.31 19.3117 110.257 20.3407 110.257 20.3407L111.969 0.345899C111.969 0.345899 75.537 -4.96828 61.2382 25.9892C50.3693 49.5143 59.8542 66.4145 65.1044 73.1032C60.0648 64.6756 59.8956 55.0275 64.6305 44.3804H64.6343Z",
    fill: "url(#paint2_linear_258_693)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0365 44.561C54.1601 69.0363 71.3322 82.1471 85.191 89.8874C91.8026 93.5754 101.555 95.7837 111.273 95.7837C118.317 95.7837 124.981 94.6157 130.547 92.3999C131.487 90.1165 135.022 77.753 135.79 75.0527C133.763 76.1757 125.481 80.3707 114.966 80.3707C106.575 80.3707 98.7677 77.7605 91.7537 72.6116C81.3512 64.9802 77.2029 55.0429 80.0762 44.6474C83.3106 32.9374 94.9241 23.0602 107.689 20.8105C107.437 20.8105 107.185 20.8105 106.929 20.8105C97.5079 20.8105 74.5628 23.1202 65.0365 44.5685V44.561Z",
    fill: "url(#paint3_linear_258_693)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_693",
    x1: 109.069,
    y1: 15.6806,
    x2: 132.956,
    y2: 6.01674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_693",
    x1: 85.1983,
    y1: 73.7272,
    x2: 135.284,
    y2: 69.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_258_693",
    x1: 51.9677,
    y1: 51.8503,
    x2: 118.771,
    y2: 11.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_258_693",
    x1: 75.8076,
    y1: 30.3085,
    x2: 120.361,
    y2: 99.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8ABAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8A8C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8C8E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.59013f5eb4d7b6fa532a20af2e15f0e3.svg";
export { ForwardRef as ReactComponent };